import React, { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TableTab from "../../../components/tabs/table-tab";
import { REPORTS_AREAS } from "../../../constants/menu-types";
import { useLocale } from "../../../contexts/localeContext";
import { TableContextProvider } from "../../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import AreaReportColumn from "../../../models/ColumnDefinitions/AreaReportColumns";
import { Filter } from "../../../models/Filter";
import { Lookup } from "../../../models/Lookup";
import LookupTypes from "../../../models/LookupTypes";
import AreaReportSearch from "../../../models/search/AreaReportSearch";
import { getDoorNamesWithPagination } from "../../../services/doorService";
import { getAreaReport } from "../../../services/reportService";
import { getZoneNamesWithPagination } from "../../../services/zoneService";
import { auditRunReport } from "../../../services/auditService";
import { getErrorMessage } from "../../../services/utilities/ServiceError";

interface AreaReportProps {
    reportId: string;
}

const AreaReport: FC<AreaReportProps> = ({ reportId }) => {
    const { translate } = useLocale();
    const lookup: Lookup[] = [
        {
            name: LookupTypes.zoneReport,
            values: [],
            dataMethod: getZoneNamesWithPagination,
            searchAccessor: AreaReportColumn.find(column => column.accessor === "zone")?.searchOnName
        },
        {
            name: LookupTypes.locationAreaReport,
            values: [],
            dataMethod: getDoorNamesWithPagination,
            searchAccessor: AreaReportColumn.find(column => column.accessor === "location")?.searchOnName
        }
    ]

    // user preference items
    const userLoginId = useSelector((state: any) => (state.userInfo.id))
    const currentMenuDetail = REPORTS_AREAS;
    const initialiseUserPreferences = (setDetails: (userLoginId, currentMenuDetail, [], reportId) => void) => {
        setDetails(userLoginId, currentMenuDetail, [], reportId);
    }
    // <-- end context

    const getDataMethod = async (listParameters?: any) => {
        try {
            await auditRunReport(reportId);
            return getAreaReport(listParameters);
        } catch (error) {
            return Promise.reject(getErrorMessage(error));
        }
    }

    return (<TableContextProvider
        dataMethod={getDataMethod}
        initialiser={(setDetails) => initialiseUserPreferences(setDetails)}
        tableDescriptor={AreaReportColumn}
        searchDescriptor={AreaReportSearch}
        useFilter
        useSort
        usePagination
        useSearch
        useTable
        lookup={lookup}>
        <TableTab
            title={''}
            reportTitle={translate.byKey(TranslationKeys.accessAreas)}
            selectRows={false}
            cyName="areaReport">
        </TableTab>
    </TableContextProvider >
    );
};

export default AreaReport;
